<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>Icons</h1>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h2>Usage</h2>
    <p>To use icons properly, consumer has to define it's size like:</p>
    <p>
      <code>{{ 'ui-icon { width: 1.5rem; height: 1.5rem; }' }}</code>
    </p>
    <p>Color of the icon is inherited as the nearest parent font color, to override use:</p>
    <p>
      <code>{{ 'ui-icon { color: red; }' }}</code>
    </p>
    <p>To use in template you have to specify the icon key. See the list of available keys along with it's visual representation below.</p>
    <p>
      <code>{{ '\<ui-icon key="lock">\</ui-icon>' }}</code>
    </p>
    <table>
      <tr *ngFor="let icon of iconList">
        <td><ui-icon [key]="icon"></ui-icon></td>
        <td class="ui-icon-label">{{ icon }}</td>
        <td>
          <ui-icon
            class="color-red"
            [key]="icon"></ui-icon>
        </td>
        <td>
          <ui-icon
            class="color-green"
            [key]="icon"></ui-icon>
        </td>
        <td>
          <ui-icon
            class="color-blue"
            [key]="icon"></ui-icon>
        </td>
        <td>
          <ui-icon
            class="color-light-gray"
            [key]="icon"></ui-icon>
        </td>
        <td>
          <ui-icon
            class="color-gray"
            [key]="icon"></ui-icon>
        </td>
      </tr>
    </table>
  </div>
</div>

<div class="row">
  <div class="row-description">
    <h2>Install</h2>
    <p>
      Import <code>UiIconsModule</code> into your application. <code>HttpClientModule</code> is a required dependency on App/Context level where your import the
      icons.
    </p>
    <p>
      For SDG icons and translation to work, connect the module with your application language Subject providing a language token at the context of the module
      import
    </p>
    <pre>{{ providersStr }}</pre>
    <p>Add the following code to copy icon assets to your application by altering your application's angular.json</p>
    <pre>{{ angularJsonStr }}</pre>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <h1>SDG Icons</h1>
  </div>
</div>

<div class="row">
  <div class="col-12 mb-5 col-sm-6">
    <table>
      <tr *ngFor="let iconKey of sdgIconList">
        <td>
          <ui-sdg-icon
            class="sdg-icon"
            id="{{ 'sdg-icon-' + iconKey }}"
            [key]="iconKey"></ui-sdg-icon>
        </td>
        <td>{{ iconKey }}</td>
      </tr>
    </table>
  </div>
</div>
